import React, { FC, ReactNode, useMemo } from 'react';
import { Menu } from 'antd';
import { CountBadge } from 'common/components';
import { ESearchParams } from 'common/const';
import { getFilterOptions } from 'common/helpers';
import { useSearchParamsHook } from 'common/hooks';
import { useAppSelector } from 'app/store/store.hooks';
import { IncomingTransferInventoryActionListTab, SentTransferInventoryActionListTab } from 'entities/Inventory/components';
import { EInventoryActionListTab } from 'entities/Inventory/Inventory.enum';
import { selectInventoryActionListUsers } from 'entities/InventoryAction/InventoryAction.slice';
import { selectUserInventoryStats } from 'entities/User/User.slice';

interface IComponentProps {
  header: ReactNode;
}

export const TransferInventoryActionListTab: FC<IComponentProps> = ({ header }) => {
  // inventory
  const inventoryActionListUsers = useAppSelector(selectInventoryActionListUsers);
  // user
  const userInventoryStats = useAppSelector(selectUserInventoryStats);

  const { getSearchParam, setSearchParam } = useSearchParamsHook();

  const { incomingTransfersCount, outcomingTransfersCount } = userInventoryStats;
  const tab = getSearchParam(ESearchParams.Tab);
  const isTransferSentInventoryActionList = tab === EInventoryActionListTab.Sent;
  const userOptions = getFilterOptions.user(inventoryActionListUsers);

  const menu = useMemo(() => {
    return (
      <Menu
        items={[
          {
            key: EInventoryActionListTab.Incoming,
            label: (
              <>
                Входящие запросы
                <CountBadge count={incomingTransfersCount} />
              </>
            ),
          },
          {
            key: EInventoryActionListTab.Sent,
            label: (
              <>
                Отправленные запросы
                <CountBadge count={outcomingTransfersCount} />
              </>
            ),
          },
        ]}
        selectedKeys={[tab === null ? EInventoryActionListTab.Incoming : tab]}
        onClick={({ key }) => setSearchParam(ESearchParams.Tab, key)}
        mode="horizontal"
      />
    );
  }, [tab, userInventoryStats]);

  return isTransferSentInventoryActionList ? (
    <SentTransferInventoryActionListTab header={header} menu={menu} userOptions={userOptions} />
  ) : (
    <IncomingTransferInventoryActionListTab header={header} menu={menu} userOptions={userOptions} />
  );
};
